import React, { useEffect, useState } from 'react';
import { useDashboardFilters } from './context/DashboardContext';
import { getTotalTokenUsage } from '../../requests.js';
import { useDispatch } from 'react-redux';
import { stopLoader, startLoader } from "../../_store/reducers/loaderReducer.js";
import ResponseLoader from '../common/ResponseLoader.js';

const TokenUsage = () => {
    const { filters } = useDashboardFilters();
    const [data, setData] = useState({
        total: 0,
        used: 0,
        remaining: 0,
    });
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        const fetchDetailsData = async () => {
            try {
                setLoading(true);
                dispatch(startLoader());
                const startDate = filters.dateRange.from;
                const endDate = filters.dateRange.to;
                const companyName = filters.company;
                const response = await getTotalTokenUsage({ startDate, endDate, companyName });
                // console.log(companyId && companyId !== "all", response?.data?.success)
                if (response?.data?.success) {

                    setData({
                        total: response?.data?.totals.totalTokenAllocated || 0,
                        used: response?.data?.totals.usedToken || 0,
                        remaining: response?.data?.totals.remainingToken || 0,
                    });

                } else {
                    // If no success response, set all to 0
                    setData({
                        total: 0,
                        used: 0,
                        remaining: 0,
                    });
                }
            } catch (error) {
                console.error("Error fetching token usage:", error);
                // On error, set all to 0
                setData({
                    total: 0,
                    used: 0,
                    remaining: 0,
                });
            } finally {
                setLoading(false); // Stop loading
                dispatch(stopLoader());
            }
        };

        fetchDetailsData();
    }, [filters]);

    // console.log("Data from token: ", data)

    return (
        <div style={{
            display: "flex",
            borderRadius: "12px",
            padding: "20px",
            flexDirection: "column",
            gap: '16px',
            borderBottom: "1px solid #D1D5DB",
            background: "#FFFFFF",
            height: "100%"
        }}>
            <div className="card-body">
                <h5 className="mb-3 d-flex align-items-center" style={{
                    fontFamily: "ClashDisplay-Semibold",
                    fontSize: "18px",
                    lineHeight: "28px",
                    color: "#000000"
                }}>
                    Token Usage
                </h5>

                {loading ? (
                    // Show loader when loading
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '150px'
                    }}>
                        <ResponseLoader />
                    </div>
                ) : (
                    // Show data when not loading
                    <ul className="list-group list-group-flush" style={{ display: 'flex', gap: '12px' }}>
                        <li className="list-group-item d-flex justify-content-between align-items-center" style={{
                            borderRadius: "6px",
                            padding: '8px 12px',
                            borderBottom: '1px solid #E5E7EB',
                            background: "#F3F4F6"
                        }}>
                            <span style={{
                                fontFamily: "Plus Jakarta Sans",
                                fontWeight: 500,
                                fontSize: "14px",
                                lineHeight: "20px",
                                color: '#6B7280'
                            }}>Total Tokens Allocated</span>
                            <span style={{
                                borderRadius: '38px',
                                padding: '4px 8px',
                                background: "#3DC7D3",
                                color: '#FFFFFF',
                                fontFamily: "Plus Jakarta Sans",
                                fontWeight: 500,
                                fontSize: "14px",
                                lineHeight: "20px",
                            }}>{data.total.toLocaleString()}</span>
                        </li>

                        <li className="list-group-item d-flex justify-content-between align-items-center" style={{
                            borderRadius: "6px",
                            padding: '8px 12px',
                            borderBottom: '1px solid #E5E7EB',
                            background: "#F3F4F6"
                        }}>
                            <span style={{
                                fontFamily: "Plus Jakarta Sans",
                                fontWeight: 500,
                                fontSize: "14px",
                                lineHeight: "20px",
                                color: '#6B7280'
                            }}>Tokens Used</span>
                            <span style={{
                                borderRadius: '38px',
                                padding: '4px 8px',
                                background: "#EAB308",
                                color: '#FFFFFF',
                                fontFamily: "Plus Jakarta Sans",
                                fontWeight: 500,
                                fontSize: "14px",
                                lineHeight: "20px",
                            }}>{data.used.toLocaleString()}</span>
                        </li>

                        <li className="list-group-item d-flex justify-content-between align-items-center" style={{
                            borderRadius: "6px",
                            padding: '8px 12px',
                            borderBottom: '1px solid #E5E7EB',
                            background: "#F3F4F6"
                        }}>
                            <span style={{
                                fontFamily: "Plus Jakarta Sans",
                                fontWeight: 500,
                                fontSize: "14px",
                                lineHeight: "20px",
                                color: '#6B7280'
                            }}>Tokens Remaining</span>
                            <span style={{
                                borderRadius: '38px',
                                padding: '4px 8px',
                                background: "#F87171",
                                color: '#FFFFFF',
                                fontFamily: "Plus Jakarta Sans",
                                fontWeight: 500,
                                fontSize: "14px",
                                lineHeight: "20px",
                            }}>{data.remaining.toLocaleString()}</span>
                        </li>
                    </ul>
                )}
            </div>
        </div>
    );
};

export default TokenUsage;